/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyledModal, StyledBody, PostPopupTop, PostButtonFeed } from '../../PhotoAndPostFlow/styles';
import {AdminCloseIcon, CommunityIcon, PublicIcon, Checkmark} from '../../../utils/icons'
import {Heading, PrivacyCheckBox} from './style'
import {RadioButton} from '../../RecogntionAdmin/styles'

class PrivacyPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tempSelectedOption: props.selectedOption 
    };
  }


  handleOptionChange = (value) => {
    this.setState({ tempSelectedOption: value }); 
  }

  updatePostStatus = () => {
    const {tempSelectedOption} = this.state;
    const {/*selectedOption,*/ updatePostApi, selectedFeedId} = this.props;
    const payload = 
    { post_id: selectedFeedId, visibility:tempSelectedOption===1?"public":"my-community" };
    updatePostApi(payload)
  }

  updatePrivacyStatus = ()=>{
    const {tempSelectedOption} = this.state;
    const {manageCheckBox,onClose}= this.props;
    manageCheckBox(tempSelectedOption);
    onClose();
  }

 

  render() {
    const {showModal, onClose,/* selectedOption, manageCheckBox,*/ singleFeed} = this.props;
    return (
      <div>
        <StyledModal show={showModal} onHide={onClose} width="400px">
          <PostPopupTop padding="20px 24px 24px 16px">
            <div className='heading'>Post Setting</div>
            <div className='closeIcon' onClick={onClose}>{AdminCloseIcon()}</div>
          </PostPopupTop>
          <div style={{height:"1px", width:"100%", background:"#EFEFEF", margin:"0"}}/>
          <StyledBody paddingValue="20px 16px 16px 16px">
            <Heading margin="0 0 20px 0">Who can see your post?</Heading>
            <PrivacyCheckBox>
              <div className='icon'>{PublicIcon()}</div>
              <div className='text'>Public</div>
              <div className="checkmark">
                <RadioButton
                  type="radio"
                  name="option"
                  // checked={selectedOption ===1 }
                  // onChange={() => manageCheckBox(1)}
                  checked={ this.state.tempSelectedOption === 1}
                  onChange={() => this.handleOptionChange(1)}
                />
              </div>
            </PrivacyCheckBox>
            <PrivacyCheckBox>
              <div className='icon'>{CommunityIcon()}</div>
              <div className='text'>My Community</div>
              <div className="checkmark">
                <RadioButton
                  type="radio"
                  name="option"
                  // checked={selectedOption ===2 }
                  // onChange={() => manageCheckBox(2)}
                  checked={ this.state.tempSelectedOption === 2}
                  onChange={() => this.handleOptionChange(2)}
                />
              </div>
            </PrivacyCheckBox>
            <PostButtonFeed width="96px" padding="12px 16px" margin="20px 0 0 0">
              <div className='button' onClick={singleFeed?()=>this.updatePostStatus():()=>this.updatePrivacyStatus()}>
                Done
                <span/>
                {Checkmark()}
              </div>
            </PostButtonFeed>
          </StyledBody>
        </StyledModal>
      </div>
    )
  }
}

PrivacyPost.propTypes = {
  history: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  manageCheckBox: PropTypes.func,
  selectedOption: PropTypes.bool,
  updatePostApi: PropTypes.bool,
  singleFeed: PropTypes.bool,
  selectedFeedId:PropTypes.number
};

export default PrivacyPost;